import { useTitle } from "../hooks/useTitle"

export const PageNotFound = ({title}) => {
    useTitle(title);
  return (
    <div>PageNotFound</div>
  )
}
